@let groupsVal = sortedGroups();
@let memberDataVal = memberData();

@if (memberDataVal) {
  @let isMemberManagedExternally = memberDataVal.managedBy !== TellentMemberManagedBy.Tellent;
  @let managedTooltipKey =
    memberDataVal.managedBy === TellentMemberManagedBy.Okta
      ? 'tlc.members.edit_member.groups_tab.managed_by_okta'
      : 'tlc.members.edit_member.groups_tab.managed_by_other';
  <rt-dialog-body variant="white" layout-vertical>
    @if (noGroups()) {
      <div class="empty-state">
        <rt-empty-state
          [title]="'tlc.members.edit_member.groups_tab.no_groups.title' | translate"
          [desc]="'tlc.members.edit_member.groups_tab.no_groups.desc' | translate"
          [icon]="'account-group'"
        >
          <rt-button (click)="vm.openAddGroupsDialog(memberDataVal)" variant="primary">
            <rt-icon name="add" />
            {{ 'tlc.members.edit_member.groups_tab.add_groups' | translate }}
          </rt-button>
        </rt-empty-state>
      </div>
    } @else {
      <div class="toolbar">
        <rt-heading variant="dark">{{
          'tlc.members.edit_member.groups_tab.added_to_groups'
            | translate: { count: $safeNavigationMigration(groupsVal?.length) }
        }}</rt-heading>
        <rt-button (click)="vm.openAddGroupsDialog(memberDataVal)" variant="primary">
          <rt-icon name="add" />
          {{ 'tlc.members.edit_member.groups_tab.add_groups' | translate }}
        </rt-button>
      </div>

      <div class="groups">
        <rt-box variant="default vertical no-padding">
          <div padding-lr>
            @for (group of groupsVal; track group.guid; let isLast = $last) {
              <div class="group">
                <div class="group-details">
                  <rt-avatar
                    type="icon"
                    iconName="account-group"
                    customIconBackgroundColor="colorAvatarGrayDark"
                    customIconColor="colorIconOncomponentDefault"
                    size="base"
                  />
                  <div class="group-name">
                    <div class="name-wrapper">
                      <rt-heading
                        ><rt-truncate>{{ group.name }}</rt-truncate></rt-heading
                      >
                    </div>
                  </div>
                </div>
                <div
                  [rtTooltip]="managedTooltipKey | translate"
                  [rtTooltipEnabled]="isMemberManagedExternally"
                  rtTooltipPosition="below"
                >
                  <rt-button
                    (click)="
                      !isMemberManagedExternally && vm.openRemoveMemberDialog(group, memberDataVal)
                    "
                    [disabled]="isMemberManagedExternally"
                    variant="plain"
                  >
                    <rt-icon name="close" />
                    {{ 'tlc.members.edit_member.groups_tab.remove_group' | translate }}
                  </rt-button>
                </div>
              </div>

              @if (!isLast) {
                <rt-divider />
              }
            }
          </div>
        </rt-box>
      </div>
    }
  </rt-dialog-body>
}
